import React from "react";
import { Container } from "react-bootstrap";
import Footer from "../../Components/Footer/Footer";
import Breadcrumbs from "react-router-dynamic-breadcrumbs";
import { Link as Router } from "react-router-dom";

const Layout = (WrappedComponent, title) => {
  const routes = {
    "/": "Home",
    "/about": "About",
    "/resources": "Resources",
    "/faq": "FAQ",
    "/privacy": "Privacy",
    "/samplecopy": "Sample Copy",
    "/publishwithus": "Publish With Us",
  };

  return (props) => (
    <div>
      <div className="section2">
        <Container>
          <div className=" breadcrumbs layoutBreadCrumbs float-right">
            <Router>
              <Breadcrumbs mappedRoutes={routes} />
            </Router>
          </div>

          <div className="about-us">{title}</div>

          <div className="box">
            <WrappedComponent />
          </div>
        </Container>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
